// Education Type and Specialization Configuration
export const EDUCATION_TYPES = [
  {
    label: "10th",
    value: "10th"
  },
  {
    label: "12th Science",
    value: "12th Science"
  },
  {
    label: "12th Commerce",
    value: "12th Commerce"
  },
  {
    label: "12th Arts",
    value: "12th Arts"
  },
  {
    label: "Medical & Paramedical",
    value: "Medical & Paramedical"
  },
  {
    label: "Engineering",
    value: "Engineering"
  },
  {
    label: "Science",
    value: "Science"
  },
  {
    label: "Commerce",
    value: "Commerce"
  },
  {
    label: "Others",
    value: "Others"
  }
];

export const SPECIALIZATIONS = {
  "10th": [
    { label: "10th Standard/SSLC", value: "10th Standard" },
    { label: "Matriculation", value: "Matriculation" },
    { label: "CBSE Class 10", value: "CBSE 10" },
    { label: "State Board Class 10", value: "State Board 10" },
    { label: "ICSE Class 10", value: "ICSE 10" }
  ],
  "12th Science": [
    { label: "12th Science (PCM) - Physics, Chemistry, Mathematics", value: "12th PCM" },
    { label: "12th Science (PCB) - Physics, Chemistry, Biology", value: "12th PCB" },
    { label: "12th Science (PCMB) - Physics, Chemistry, Math, Biology", value: "12th PCMB" },
    { label: "CBSE 12th Science", value: "CBSE 12th Science" },
    { label: "State Board 12th Science", value: "State Board 12th Science" },
    { label: "ISC 12th Science", value: "ISC 12th Science" }
  ],
  "12th Commerce": [
    { label: "12th Commerce with Mathematics", value: "12th Commerce Math" },
    { label: "12th Commerce without Mathematics", value: "12th Commerce" },
    { label: "CBSE 12th Commerce", value: "CBSE 12th Commerce" },
    { label: "State Board 12th Commerce", value: "State Board 12th Commerce" },
    { label: "ISC 12th Commerce", value: "ISC 12th Commerce" }
  ],
  "12th Arts": [
    { label: "12th Arts/Humanities", value: "12th Arts" },
    { label: "12th Arts with English", value: "12th Arts English" },
    { label: "12th Arts with History", value: "12th Arts History" },
    { label: "12th Arts with Geography", value: "12th Arts Geography" },
    { label: "12th Arts with Political Science", value: "12th Arts Political" },
    { label: "12th Arts with Economics", value: "12th Arts Economics" },
    { label: "CBSE 12th Arts", value: "CBSE 12th Arts" },
    { label: "State Board 12th Arts", value: "State Board 12th Arts" },
    { label: "ISC 12th Arts", value: "ISC 12th Arts" }
  ],
  "Medical & Paramedical": [
    { label: "MBBS", value: "MBBS" },
    { label: "BDS", value: "BDS" },
    { label: "BAMS", value: "BAMS" },
    { label: "BHMS", value: "BHMS" },
    { label: "BPT", value: "BPT" },
    { label: "BNYS", value: "BNYS" },
    { label: "B.Pharm", value: "B.Pharm" },
    { label: "D.Pharm", value: "D.Pharm" },
    { label: "B.Sc Nursing", value: "B.Sc Nursing" },
    { label: "GNM (General Nursing and Midwifery)", value: "GNM" },
    { label: "ANM (Auxiliary Nursing and Midwifery)", value: "ANM" },
    { label: "B.Sc Medical Laboratory Technology", value: "B.Sc MLT" },
    { label: "B.Sc Radiology and Imaging Technology", value: "B.Sc Radiology" },
    { label: "B.Sc Operation Theatre Technology", value: "B.Sc OTT" },
    { label: "B.Sc Optometry", value: "B.Sc Optometry" },
    { label: "B.Sc Cardiology Technology", value: "B.Sc Cardiology" },
    { label: "B.Sc Respiratory Care Technology", value: "B.Sc RCT" },
    { label: "B.Sc Anesthesia Technology", value: "B.Sc Anesthesia" },
    { label: "B.Sc Dialysis Technology", value: "B.Sc Dialysis" },
    { label: "Doctor of Medicine (MD)", value: "MD" },
    { label: "Master of Surgery (MS)", value: "MS" },
    { label: "Master of Dental Surgery (MDS)", value: "MDS" },
    { label: "M.Pharm", value: "M.Pharm" },
    { label: "M.Sc Nursing", value: "M.Sc Nursing" },
    { label: "Master of Public Health (MPH)", value: "MPH" },
    { label: "Master of Hospital Administration (MHA)", value: "MHA" },
    { label: "Other Medical Course", value: "Other Medical" }
  ],
  "Engineering": [
    { label: "B.Tech/B.E. Computer Science Engineering", value: "B.Tech CSE" },
    { label: "B.Tech/B.E. Information Technology", value: "B.Tech IT" },
    { label: "B.Tech/B.E. Electronics and Communication Engineering", value: "B.Tech ECE" },
    { label: "B.Tech/B.E. Electrical Engineering", value: "B.Tech EE" },
    { label: "B.Tech/B.E. Mechanical Engineering", value: "B.Tech ME" },
    { label: "B.Tech/B.E. Civil Engineering", value: "B.Tech Civil" },
    { label: "B.Tech/B.E. Aeronautical Engineering", value: "B.Tech Aero" },
    { label: "B.Tech/B.E. Chemical Engineering", value: "B.Tech Chemical" },
    { label: "B.Tech/B.E. Biotechnology Engineering", value: "B.Tech Biotech" },
    { label: "B.Tech/B.E. Environmental Engineering", value: "B.Tech Env" },
    { label: "B.Tech/B.E. Mechatronics Engineering", value: "B.Tech Mechatronics" },
    { label: "B.Tech/B.E. Mining Engineering", value: "B.Tech Mining" },
    { label: "B.Tech/B.E. Petroleum Engineering", value: "B.Tech Petroleum" },
    { label: "B.Tech/B.E. Textile Engineering", value: "B.Tech Textile" },
    { label: "B.Tech/B.E. Marine Engineering", value: "B.Tech Marine" },
    { label: "B.Tech/B.E. Automobile Engineering", value: "B.Tech Auto" },
    { label: "B.Tech/B.E. Production Engineering", value: "B.Tech Production" },
    { label: "B.Tech/B.E. Industrial Engineering", value: "B.Tech Industrial" },
    { label: "B.Tech/B.E. Artificial Intelligence", value: "B.Tech AI" },
    { label: "B.Tech/B.E. Data Science", value: "B.Tech DS" },
    { label: "B.Tech/B.E. Cyber Security", value: "B.Tech Cyber" },
    { label: "Diploma in Computer Science Engineering", value: "Diploma CSE" },
    { label: "Diploma in Information Technology", value: "Diploma IT" },
    { label: "Diploma in Electronics and Communication Engineering", value: "Diploma ECE" },
    { label: "Diploma in Electrical Engineering", value: "Diploma EE" },
    { label: "Diploma in Mechanical Engineering", value: "Diploma ME" },
    { label: "Diploma in Civil Engineering", value: "Diploma Civil" },
    { label: "Diploma in Automobile Engineering", value: "Diploma Auto" },
    { label: "Diploma in Chemical Engineering", value: "Diploma Chemical" },
    { label: "M.Tech/M.E. Computer Science Engineering", value: "M.Tech CSE" },
    { label: "M.Tech/M.E. Information Technology", value: "M.Tech IT" },
    { label: "M.Tech/M.E. Electronics and Communication Engineering", value: "M.Tech ECE" },
    { label: "M.Tech/M.E. Electrical Engineering", value: "M.Tech EE" },
    { label: "M.Tech/M.E. Mechanical Engineering", value: "M.Tech ME" },
    { label: "M.Tech/M.E. Civil Engineering", value: "M.Tech Civil" },
    { label: "Other Engineering Course", value: "Other Engineering" }
  ],
  "Science": [
    { label: "B.Sc Physics", value: "B.Sc Physics" },
    { label: "B.Sc Chemistry", value: "B.Sc Chemistry" },
    { label: "B.Sc Mathematics", value: "B.Sc Mathematics" },
    { label: "B.Sc Biology", value: "B.Sc Biology" },
    { label: "B.Sc Botany", value: "B.Sc Botany" },
    { label: "B.Sc Zoology", value: "B.Sc Zoology" },
    { label: "B.Sc Microbiology", value: "B.Sc Microbiology" },
    { label: "B.Sc Biochemistry", value: "B.Sc Biochemistry" },
    { label: "B.Sc Biotechnology", value: "B.Sc Biotechnology" },
    { label: "B.Sc Computer Science", value: "B.Sc CS" },
    { label: "B.Sc Information Technology", value: "B.Sc IT" },
    { label: "B.Sc Statistics", value: "B.Sc Statistics" },
    { label: "B.Sc Geography", value: "B.Sc Geography" },
    { label: "B.Sc Geology", value: "B.Sc Geology" },
    { label: "B.Sc Environmental Science", value: "B.Sc Environmental" },
    { label: "B.Sc Forestry", value: "B.Sc Forestry" },
    { label: "B.Sc Agriculture", value: "B.Sc Agriculture" },
    { label: "B.Sc Horticulture", value: "B.Sc Horticulture" },
    { label: "B.Sc Food Technology", value: "B.Sc Food Tech" },
    { label: "B.Sc Nutrition and Dietetics", value: "B.Sc Nutrition" },
    { label: "Bachelor of Science (General)", value: "B.Sc General" },
    { label: "M.Sc Physics", value: "M.Sc Physics" },
    { label: "M.Sc Chemistry", value: "M.Sc Chemistry" },
    { label: "M.Sc Mathematics", value: "M.Sc Mathematics" },
    { label: "M.Sc Biology", value: "M.Sc Biology" },
    { label: "M.Sc Botany", value: "M.Sc Botany" },
    { label: "M.Sc Zoology", value: "M.Sc Zoology" },
    { label: "M.Sc Microbiology", value: "M.Sc Microbiology" },
    { label: "M.Sc Biochemistry", value: "M.Sc Biochemistry" },
    { label: "M.Sc Biotechnology", value: "M.Sc Biotechnology" },
    { label: "M.Sc Computer Science", value: "M.Sc CS" },
    { label: "M.Sc Information Technology", value: "M.Sc IT" },
    { label: "Master of Science (General)", value: "M.Sc General" },
    { label: "Other Science Course", value: "Other Science" }
  ],
  "Commerce": [
    { label: "B.Com (General)", value: "B.Com General" },
    { label: "B.Com (Honours)", value: "B.Com Honours" },
    { label: "B.Com Accounting and Finance", value: "B.Com AF" },
    { label: "B.Com Banking and Insurance", value: "B.Com BI" },
    { label: "B.Com Computer Applications", value: "B.Com CA" },
    { label: "B.Com E-Commerce", value: "B.Com EC" },
    { label: "B.Com International Business", value: "B.Com IB" },
    { label: "B.Com Taxation", value: "B.Com Tax" },
    { label: "Bachelor of Business Administration (BBA)", value: "BBA" },
    { label: "BBA Finance", value: "BBA Finance" },
    { label: "BBA Marketing", value: "BBA Marketing" },
    { label: "BBA Human Resources", value: "BBA HR" },
    { label: "BBA International Business", value: "BBA IB" },
    { label: "BBA Banking and Financial Services", value: "BBA BFS" },
    { label: "Bachelor of Economics", value: "B.Econ" },
    { label: "Bachelor of Financial Markets (BFM)", value: "BFM" },
    { label: "Bachelor of Management Studies (BMS)", value: "BMS" },
    { label: "Chartered Accountancy (CA)", value: "CA" },
    { label: "Company Secretary (CS)", value: "CS" },
    { label: "Cost and Management Accountant (CMA)", value: "CMA" },
    { label: "M.Com (General)", value: "M.Com General" },
    { label: "M.Com Accounting and Finance", value: "M.Com AF" },
    { label: "M.Com Banking and Finance", value: "M.Com BF" },
    { label: "M.Com International Business", value: "M.Com IB" },
    { label: "Master of Business Administration (MBA)", value: "MBA" },
    { label: "MBA Finance", value: "MBA Finance" },
    { label: "MBA Marketing", value: "MBA Marketing" },
    { label: "MBA Human Resources", value: "MBA HR" },
    { label: "MBA Operations", value: "MBA Operations" },
    { label: "MBA International Business", value: "MBA IB" },
    { label: "MBA Banking and Financial Services", value: "MBA BFS" },
    { label: "Master of Economics", value: "M.Econ" },
    { label: "Master of Financial Management (MFM)", value: "MFM" },
    { label: "Other Commerce Course", value: "Other Commerce" }
  ],
  "Others": [
    { label: "Bachelor of Arts (BA)", value: "BA" },
    { label: "BA English", value: "BA English" },
    { label: "BA History", value: "BA History" },
    { label: "BA Political Science", value: "BA Political" },
    { label: "BA Psychology", value: "BA Psychology" },
    { label: "BA Sociology", value: "BA Sociology" },
    { label: "BA Philosophy", value: "BA Philosophy" },
    { label: "BA Economics", value: "BA Economics" },
    { label: "BA Geography", value: "BA Geography" },
    { label: "BA Hindi", value: "BA Hindi" },
    { label: "BA Urdu", value: "BA Urdu" },
    { label: "BA Arabic", value: "BA Arabic" },
    { label: "BA Islamic Studies", value: "BA Islamic" },
    { label: "Bachelor of Education (B.Ed)", value: "B.Ed" },
    { label: "Bachelor of Physical Education (B.P.Ed)", value: "B.P.Ed" },
    { label: "Bachelor of Library and Information Science (B.Lib)", value: "B.Lib" },
    { label: "Bachelor of Social Work (BSW)", value: "BSW" },
    { label: "Bachelor of Journalism and Mass Communication (BJMC)", value: "BJMC" },
    { label: "Bachelor of Fine Arts (BFA)", value: "BFA" },
    { label: "Bachelor of Design", value: "B.Design" },
    { label: "Bachelor of Architecture (B.Arch)", value: "B.Arch" },
    { label: "Bachelor of Law (LLB)", value: "LLB" },
    { label: "Bachelor of Hotel Management (BHM)", value: "BHM" },
    { label: "Bachelor of Computer Applications (BCA)", value: "BCA" },
    { label: "Bachelor of Vocational Studies", value: "B.Voc" },
    { label: "Master of Arts (MA)", value: "MA" },
    { label: "MA English", value: "MA English" },
    { label: "MA History", value: "MA History" },
    { label: "MA Political Science", value: "MA Political" },
    { label: "MA Psychology", value: "MA Psychology" },
    { label: "MA Sociology", value: "MA Sociology" },
    { label: "MA Philosophy", value: "MA Philosophy" },
    { label: "MA Economics", value: "MA Economics" },
    { label: "MA Geography", value: "MA Geography" },
    { label: "MA Hindi", value: "MA Hindi" },
    { label: "MA Urdu", value: "MA Urdu" },
    { label: "MA Arabic", value: "MA Arabic" },
    { label: "MA Islamic Studies", value: "MA Islamic" },
    { label: "Master of Education (M.Ed)", value: "M.Ed" },
    { label: "Master of Physical Education (M.P.Ed)", value: "M.P.Ed" },
    { label: "Master of Library and Information Science (M.Lib)", value: "M.Lib" },
    { label: "Master of Social Work (MSW)", value: "MSW" },
    { label: "Master of Journalism and Mass Communication (MJMC)", value: "MJMC" },
    { label: "Master of Fine Arts (MFA)", value: "MFA" },
    { label: "Master of Design", value: "M.Design" },
    { label: "Master of Architecture (M.Arch)", value: "M.Arch" },
    { label: "Master of Law (LLM)", value: "LLM" },
    { label: "Master of Hotel Management (MHM)", value: "MHM" },
    { label: "Master of Computer Applications (MCA)", value: "MCA" },
    { label: "Master of Vocational Studies", value: "M.Voc" },
    { label: "Diploma Courses", value: "Diploma" },
    { label: "Certificate Courses", value: "Certificate" },
    { label: "Other Course", value: "Other" }
  ]
};

// Function to get specializations based on education type
export const getSpecializationsByType = (educationType) => {
  return SPECIALIZATIONS[educationType] || [];
};